import mitt from 'mitt'

export const emitter = mitt();

window.$emit = (type, event = undefined) => emitter.emit(type, event)

export const useEmitter = controller => {
    const events = []

    Object.assign(controller, {
        $on(type, handler) {
            events.push({ type, handler })

            emitter.on(type, handler)
        },

        $emit(type, event = undefined) {
            emitter.emit(type, event)
        },

        $clear() {
            events.forEach(({ type, handler }) => {
                emitter.off(type, handler)
            })

            events.splice(0, events.length)
        }
    });
};